import React from "react";

/**
 * PositiveSSL TrustLogo Component
 * Displays the PositiveSSL secure site seal on login pages using iframe
 * This approach isolates the PositiveSSL script from React to prevent conflicts
 * 
 * Usage: <PositiveSSLSeal />
 */
function PositiveSSLSeal() {
    return (
        <div className="tw-flex tw-justify-center tw-items-center tw-mt-4">
            <iframe
                src="/positivessl-seal.html"
                style={{
                    border: "none",
                    width: "200px",
                    height: "60px",
                    overflow: "hidden",
                }}
                title="PositiveSSL Security Seal"
                scrolling="no"
            />
        </div>
    );
}

export default PositiveSSLSeal;
